import { z } from 'zod';
import { SelectFieldParamsSchema } from './selectfield';
import { InitialUIElement } from '../initial-ui-element';
import { CommonOption } from '../common';

export const INDUSTRIES_PICKER_FIELD_ELEMENT_TYPE = 'industriespickerfield' as const;
export const IndustriesPickerFieldElementType = z.literal(INDUSTRIES_PICKER_FIELD_ELEMENT_TYPE);

export const IndustriesPickerFieldParamsSchema = SelectFieldParamsSchema.extend({
  options: z.array(CommonOption),
});

export type TIndustriesPickerFieldParams = z.infer<typeof IndustriesPickerFieldParamsSchema>;

export const IndustriesPickerFieldElementSchema = InitialUIElement.extend({
  element: IndustriesPickerFieldElementType,
  params: IndustriesPickerFieldParamsSchema,
});
